<template>
  <div class="tcs_box" v-html="html" v-loading="tcsBoxLoading"></div>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    tcsKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      html: '',
      tcsBoxLoading: false,
    };
  },
  methods: {
    async initHtml() {
      try {
        this.tcsBoxLoading = true;
        const { data } = await axios.post(`${process.env.VUE_APP_API_TSC_URL}/official/consultativeManagement/queryConsultativeByCode`, {
          consultativeCode: this.tcsKey,
          productCode: 'CPBMXS1Y6UPB9V',
        });
        this.tcsBoxLoading = false;
        console.log('data', data);
        this.html = data.data.consultativeLabel
          .replace(/<table style="width: auto;"/g, '<div style="width: 100%;overflow: scroll;"><table style="width: max-content;"')
          .replace(/<\/table>/g, '</table></div>');
      } catch (error) {
        console.log(error);
        this.tcsBoxLoading = false;
      }
    },
  },
  mounted() {
    this.initHtml();
  },
};
</script>
<style lang="scss">
.tcs_box {
  padding: 30px;
  h1 {
    font-size: 2em;
    strong {
      font-size: inherit;
    }
  }
  h2 {
    font-size: 1.5em;
    font-weight: bold;
  }
  h3 {
    font-size: 1.3em;
    font-weight: bold;
  }
  h4 {
    font-size: 1.2em;
    font-weight: bold;
  }
  h5 {
    font-size: 1.1em;
    font-weight: bold;
  }
  h6 {
    font-size: 1em;
    font-weight: bold;
  }
  p {
    padding-bottom: 20px;
    margin-bottom: 0;
    font-weight: 400;
    color: #666;
    line-height: 28px;
  }
}
</style>
